import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import { ModalFooter } from 'react-bootstrap';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const ReviewTemplateModalFooter = ({
  isManualReviewMode,
}: {
  isManualReviewMode: boolean;
}) => {
  const { t } = useTranslation();
  const { isSubmitting } = useFormState();

  const submitButtonLabel = isManualReviewMode
    ? t(
        'pageAutomations.reviews.guestReviewTemplates.modal.publishManualReview',
      )
    : t(
        'pageAutomations.reviews.guestReviewTemplates.modal.saveReviewTemplate',
      );

  return (
    <ModalFooter>
      <ModalFormCancelButton />
      <ModalFormSubmitButton>
        {isSubmitting ? t('common.saving') : submitButtonLabel}
      </ModalFormSubmitButton>
    </ModalFooter>
  );
};

export default ReviewTemplateModalFooter;
